import React, { useEffect, useRef } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import structure from "./structure";

const Content = () => {
  const containerRef = useRef(null);
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (typeof hash === "string" && hash.length > 1) {
      const elementId = location.hash.slice(1);
      const timeout = setTimeout(() => {
        const element = document.getElementById(elementId);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 500);
      return () => {
        clearTimeout(timeout);
      };
    }
    containerRef.current?.scrollTo(0, 0);
  }, [pathname, hash]);

  return (
    <Box
      ref={containerRef}
      sx={{ px: 8, py: 4, flexGrow: 1, height: "100%", overflowY: "auto" }}
    >
      <Routes>
        {structure.map((s) => (
          <Route
            key={s.path}
            path={`${s.path}/*`}
            element={
              <Routes>
                {s.items.map((i) => {
                  const IComponent = i.component;
                  return (
                    <Route
                      key={i.path}
                      path={`${i.path}/*`}
                      element={
                        <React.Fragment>
                          {IComponent && <IComponent />}
                          {i.group && (
                            <Routes>
                              {i.group.map((g) => {
                                const GComponent = g.component;
                                if (!GComponent) return null;
                                return (
                                  <Route
                                    key={g.path}
                                    path={g.path}
                                    element={<GComponent />}
                                  />
                                );
                              })}
                            </Routes>
                          )}
                        </React.Fragment>
                      }
                    />
                  );
                })}
              </Routes>
            }
          />
        ))}
        <Route path="*" element={<Navigate to="/overview/getting-started" />} />
      </Routes>
    </Box>
  );
};

export default Content;
